export const useLotFormSecureDeal = () => {
  const lotForm = useLotForm()

  const selectedCategory = computed(() => {
    const categories = lotForm.categories.value
    if (!categories.length) {
      return null
    }
    return categories[categories.length - 1]
  })

  const isLeafCategorySelected = computed(() => {
    return Boolean(selectedCategory.value && !selectedCategory.value.hasChildren)
  })

  const categorySettings = computed(() => {
    const categoryId = selectedCategory.value?.id
    if (!categoryId) {
      return null
    }
    return useCategories().getCategoryById(Number(categoryId))
  })

  const categorySecureDealMode = computed(() => categorySettings.value?.secureDeal)

  const isOptionalMode = computed(() => categorySecureDealMode.value === 'OPTIONAL')
  const isMandatoryMode = computed(() => categorySecureDealMode.value === 'MANDATORY')
  const isDisabledMode = computed(() => categorySecureDealMode.value === 'DISABLED')

  const secureDealField = computed(() => {
    const value = lotForm.item.value?.secureDealField
    if (typeof value === 'boolean') {
      return value
    }
    return true
  })

  const isSecureDealActive = computed(() => {
    if (!isLeafCategorySelected.value) {
      return false
    }
    if (isMandatoryMode.value) {
      return true
    }
    if (isDisabledMode.value) {
      return false
    }
    if (isOptionalMode.value) {
      return secureDealField.value
    }
    return true
  })

  const commissionPercent = computed(() => {
    const lotCoefficient = lotForm.item.value?.ownerFeeCoefficient
    const coefficient = lotCoefficient != null && lotCoefficient !== ''
      ? lotCoefficient
      : categorySettings.value?.ownerFeeCoefficient
    if (coefficient == null || coefficient === '') {
      return 20
    }
    return Math.round(Number(coefficient) * 100)
  })

  const hasInsurance = computed(() => Boolean(categorySettings.value?.insurance))
  const hasOptionalPrice = computed(() => Boolean(categorySettings.value?.optionalPrice))

  const caption = computed(() => {
    if (!isLeafCategorySelected.value) {
      return null
    }
    if (isMandatoryMode.value) {
      return 'Для этой категории безопасная сделка обязательна'
    }
    if (isDisabledMode.value) {
      return 'Для этой категории безопасная сделка недоступна'
    }
    return null
  })

  return {
    selectedCategory,
    isLeafCategorySelected,
    categorySettings,
    categorySecureDealMode,
    isOptionalMode,
    isMandatoryMode,
    isDisabledMode,
    secureDealField,
    isSecureDealActive,
    commissionPercent,
    hasInsurance,
    hasOptionalPrice,
    caption,
  }
}
